/* 函数命名规则
* rulesXxx      单条检验规格
* validatorXxx  自定义校验函数
* validatorFragmentXxx  自定义校验函数片段
* */
/**
 * 不能为空
 */
export function rulesNotEmpty(name=''){
  return {trigger: ["blur","change"],required:true,message:`${name+''}不能为空`, }
}

/**
 * 正数
 */
export function validatorFragmentIsPositiveNumber(rule, value, callback) {
  let num = parseFloat(value);
  if(num<=0) return callback(new Error('不能小于0'));
  return '';
}
/**
 * 浮点数
 */
export function validatorFragmentIsFloat(rule, value, callback) {
  let isFloat = /^-?[0-9]+(.[0-9]+)?$/ig.test(value);
  if(!isFloat) return callback(new Error('只支持数字(小数)'));
  return '';
}

/**
 * 整数
 */
export function validatorFragmentIsInteger(rule, value, callback) {
  let isFloat = /^-?[0-9]+$/ig.test(value);
  if(!isFloat) return callback(new Error('只支持整数'));
  return '';
}
/**
 * 正整数
 */
export function validatorFragmentIsPositiveInteger(rule, value, callback) {
  let judge = validatorFragmentIsInteger(...arguments);
  if(judge) return judge;
  let num = parseInt(value);
  if(num<1) return callback(new Error('不能小于1'));
  return '';
}

/**
 * 商品数量
 */
export function validatorGoodsQuantity(rule, value, callback) {
  let judge = validatorFragmentIsPositiveInteger(...arguments);
  if(judge) return judge;
  callback();
}
/**
 * 商品价格
 */
export function validatorGoodsPrice(rule, value, callback) {
  let judge = validatorFragmentIsFloat(...arguments);
  if(judge) return judge;
  judge = validatorFragmentIsPositiveNumber(...arguments);
  if(judge) return judge;
  callback();
}



// WEBPACK FOOTER //
// ./src/assets/js/formRules.js